import { IHttpApi } from '@cian/http-api/shared';
import {
  fetchGetRegionCities,
  IGetRegionCitiesRequest,
  IGetRegionCitiesResponse,
  IGetRegionCitiesResponse200,
  IGetRegionCitiesResponse400,
} from '../repositories/monolith-python/v1/get-region-cities';

export async function getRegionCities(httpApi: IHttpApi, parameters: IGetRegionCitiesRequest, subdomain?: string) {
  const { response, statusCode } = await fetchGetRegionCities<IGetRegionCitiesResponse200, IGetRegionCitiesResponse400>(
    {
      httpApi,
      parameters,
      config: {
        subdomain: subdomain || 'www',
      },
    },
  );

  if (statusCode !== 200) {
    throw response;
  }

  return response as IGetRegionCitiesResponse;
}
